import { render, staticRenderFns } from "./other.vue?vue&type=template&id=c2b5fb52&scoped=true"
import script from "./other.vue?vue&type=script&lang=js"
export * from "./other.vue?vue&type=script&lang=js"
import style0 from "./other.vue?vue&type=style&index=0&id=c2b5fb52&prod&lang=scss&scoped=true"
import style1 from "./other.vue?vue&type=style&index=1&id=c2b5fb52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b5fb52",
  null
  
)

export default component.exports